/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { GearIcon } from 'components/CommonIcons';
import WithClickOutside from '../../../WithClickOutside';
import AddColumnsHeaderRowMenu from './AddColumnsHeaderRowMenu';
import * as styles from './AddColumnsHeaderRowRenderer.scss';

/**
 * CustomHeaderRowRenderer Component in Table
 * @function AddColumnsHeaderRowRenderer
 * @param {string} className  -- className of input
 * @param {Object} columns -- array of objects representing column data
 * @param {Object} style -- wrapper div style
 * @returns {JSX.Element}
 */
class AddColumnsHeaderRowRenderer extends Component {
  static propTypes = {
    allColumns: PropTypes.array.isRequired,
    selectedColumns: PropTypes.array.isRequired,
    className: PropTypes.string,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  };

  static defaultProps = {
    className: null,
    style: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      columnMenuHidden: true,
    };
  }

  toggleColumnMenu = () => {
    const { columnMenuHidden } = this.state;

    this.setState({
      columnMenuHidden: !columnMenuHidden,
    });
  };

  hideColumnMenu = () => {
    this.setState({
      columnMenuHidden: true,
    });
  };

  render() {
    const { className, columns, style, toggleColumn, selectedColumns, allColumns } = this.props;
    const { columnMenuHidden } = this.state;

    const newStyle = { ...style, overflow: 'visible' };
    return (
      <div className={classNames(className, styles.rowContainer)} role="row" style={newStyle}>
        {columns}
        <WithClickOutside
          className={styles.headerRowMenuContainer}
          handleClickOutside={this.hideColumnMenu}>
          <div
            className={styles.addFilterIcon}
            onClick={this.toggleColumnMenu}
            >
            <div>
              <GearIcon />
            </div>
          </div>
          {!columnMenuHidden
            && <AddColumnsHeaderRowMenu
              allColumns={allColumns}
              selectedColumns={selectedColumns}
              toggleColumn={toggleColumn}
              hideColumnMenu={this.hideColumnMenu} />}
        </WithClickOutside>
      </div>
    );
  }
}

export default AddColumnsHeaderRowRenderer;
